module.exports = __webpack_public_path__ + "static/img/swiper3.aee52c3.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/swiper3.jpeg
// module id = Tz5q
// module chunks = 0